'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var constants = require('./constants.js');

var getTypeOfScore = function (score) {
    if (score > constants.COLOR_CUTOFFS.high)
        return 'high';
    if (score > constants.COLOR_CUTOFFS.medium)
        return 'medium';
    return 'low';
};
var getColorFromTypeOfScore = function (typeOfScore) {
    return constants.COLORS[typeOfScore];
};
var getColorFromScore = function (score) {
    var typeOfScore = getTypeOfScore(score);
    return getColorFromTypeOfScore(typeOfScore);
};
var getPercentage = function (score) {
    var modifiedScore = score;
    if (score < 0) {
        modifiedScore = 0;
    }
    if (score > 10) {
        modifiedScore = 10;
    }
    return modifiedScore * 10 + "%";
};
var isEnterKey = function (code) {
    return code === constants.ENTER_KEYCODE;
};

exports.getColorFromScore = getColorFromScore;
exports.getColorFromTypeOfScore = getColorFromTypeOfScore;
exports.getPercentage = getPercentage;
exports.getTypeOfScore = getTypeOfScore;
exports.isEnterKey = isEnterKey;
